module.exports = __webpack_public_path__ + "img/pro_two_9.33d4e298.jpg";